import { GridPanelControl } from 'features/layout/grid-panel/GridPanelControl';
import { selectIsLockedContentReadOnly } from 'features/layout/features/content/contentSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { PermissionTypes } from 'features/permissions/types';
import { usePermissions } from 'features/permissions/usePermissions';
import { selectSelectedScreenshare } from 'features/screenshare/screenshareSlice';
import { selectLocalUserId, selectUserById } from 'features/users/usersSlice';
import { localScreenshareStopped, stopRemoteScreenshare } from 'features/screenshare/actions';
import { useTranslation } from 'react-i18next';

export const useScreensharePanelCloseControl = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation('room');

  const { hasPermissions } = usePermissions();

  const selectedScreenshare = useAppSelector(selectSelectedScreenshare);
  const localUserId = useAppSelector(selectLocalUserId);
  const userId = selectedScreenshare?.userId ?? '';
  const user = useAppSelector((state) => selectUserById(state, userId));
  const isLocalScreenshare = userId === localUserId;

  const canManageScreenshare = hasPermissions(PermissionTypes.manageScreenshare, {
    targetRole: user?.role,
  });
  const isLockedContentReadOnly = useAppSelector(selectIsLockedContentReadOnly);

  const handleClick = () => {
    if (selectedScreenshare) {
      if (isLocalScreenshare) {
        dispatch(localScreenshareStopped());
      } else {
        dispatch(stopRemoteScreenshare(selectedScreenshare.userId));
      }
    }
  };

  return {
    controlEnabled: (canManageScreenshare || isLocalScreenshare) && !isLockedContentReadOnly,
    isLocalScreenshare,
    handleClick,
    tooltip: t('tooltips.close_content'),
  };
};

export const ScreensharePanelCloseControl = () => {
  const { controlEnabled, handleClick, tooltip } = useScreensharePanelCloseControl();

  return controlEnabled ? (
    <GridPanelControl tooltip={tooltip} icon="close" onClick={handleClick} />
  ) : null;
};
